var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class PermissionsProxyApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'permissions';
    }
    enc(value) {
        return encodeURIComponent(value);
    }
    baseRoute(environmentId, accountId) {
        return `${this.apiBasePath}/${this.enc(environmentId)}/${this.enc(accountId)}`;
    }
    userRoute(environmentId, accountId, userId) {
        return `${this.baseRoute(environmentId, accountId)}/users/${this.enc(userId)}`;
    }
    environmentRoute(environmentId) {
        return `${this.apiBasePath}/${this.enc(environmentId)}/defaults`;
    }
    getUserPermissions(environmentId, accountId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: this.userRoute(environmentId, accountId, userId),
            });
        });
    }
    updateUserPermissions(environmentId, accountId, userId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: this.userRoute(environmentId, accountId, userId),
                data,
            });
        });
    }
    getMultiUserPermissions(environmentId, accountId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.userRoute(environmentId, accountId, userId)}/environment`,
            });
        });
    }
    updateMultiUserPermissions(environmentId, accountId, userId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.userRoute(environmentId, accountId, userId)}/environment`,
                data,
            });
        });
    }
    resetUserPermissions(environmentId, accountId, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.userRoute(environmentId, accountId, userId)}/reset`,
            });
        });
    }
    getAccountDefaultPermissions(environmentId, accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.baseRoute(environmentId, accountId)}/defaults`,
            });
        });
    }
    updateAccountDefaultPermissions(environmentId, accountId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.baseRoute(environmentId, accountId)}/defaults`,
                data,
            });
        });
    }
    resetAccountDefaultPermissions(environmentId, accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.baseRoute(environmentId, accountId)}/defaults/overrides`,
            });
        });
    }
    getEnvironmentDefaultPermissions(environmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: this.environmentRoute(environmentId),
            });
        });
    }
    updateEnvironmentDefaultPermissions(environmentId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: this.environmentRoute(environmentId),
                data,
            });
        });
    }
    resetEnvironmentDefaultPermissions(environmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.environmentRoute(environmentId)}/overrides`,
            });
        });
    }
}
//# sourceMappingURL=index.js.map